import { dateUtils } from 'scbk-shared-module/utils';
import { create } from 'zustand';
import { HolidayInfo } from '../types/api/utlFncHldList';

export interface HolidayState {
  holidayList: HolidayInfo[];
  setHolidayList: (holidayList: HolidayInfo[]) => void;
  getHolidayList: () => HolidayInfo[];
  isHoliday: (date?: string) => boolean;
}

export const useHolidayStore = create<HolidayState>((set, get) => ({
  holidayList: [],
  setHolidayList: (newHolidayList) =>
    set((state) => ({
      holidayList: [...state.holidayList, ...newHolidayList],
    })),
  getHolidayList: () => {
    return get().holidayList ?? [];
  },
  isHoliday: (date = dateUtils.getToday()) => {
    return get().holidayList.some((h) => h.date === date) || dateUtils.isWeekend(date);
  },
}));
